'use strict';

$(document).ready(function () {
    $('.reward-points-calc-link').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var productId = $(this).data('product-id');

        $.spinner().start();

        // Call SFCC controller via AJAX and expect HTML fragment
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                pid: productId
            },
            dataType: 'html',
            success: function (htmlResponse) {
                $.spinner().stop();
                // Insert the returned ISML fragment into the modal body and show modal
                $('.loyalty-redeem-modal-test').html(htmlResponse);
                $('#rewardPointsModal').modal('show');
            },
            error: function () {
                $.spinner().stop();
                $('#rewardPointsModal').modal('show');
            }
        });
    });
});
